import React, { memo } from "react";

function IconConceptAttributeType({ color = "white", ...props }) {
    return (
        <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 21H4C3.73478 21 3.48043 20.8946 3.29289 20.7071C3.10536 20.5196 3 20.2652 3 20V7L7 3H16C16.2652 3 16.5196 3.10536 16.7071 3.29289C16.8946 3.48043 17 3.73478 17 4V10" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7 9H13M17 14L15.76 16.3L13 16.67L15 18.47L14.53 21L17 19.8L19.47 21L19 18.47L21 16.67L18.24 16.3L17 14ZM7 13H13H7Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export default memo(IconConceptAttributeType);